import BaseComponent from "../../../baseComponent.js";
import NumberAbbreviator from "../../../../core/utils/numberAbbreviator.js";
import styles from "./legnend.scss";

export default class NonFloatingLegends extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(nextProps) {
    var total = 0, totalPercent = 0;
    for (var i = 0; i < nextProps.data.length; i++) {
      total += nextProps.data[i].y;
    }
    for (var i = 0; i < nextProps.data.length; i++) {
      var percentValue = nextProps.data[i].y > 0 ? nextProps.data[i].y / total * 100 : 0;
      percentValue = Math.round(percentValue * 10) / 10;
      if (i === nextProps.data.length - 1) {
        percentValue = Math.round((100 - totalPercent) * 10) / 10;
      }
      totalPercent += percentValue;

      var value = NumberAbbreviator.format(nextProps.data[i].y);
      const legendElement = $(this.refs.container).find(".pie-chart-legend[data-identifier='" + nextProps.data[i].identifier + "']");
      const valueElement = $(this.refs.container).find(".pie-chart-legend__value[data-identifier='" + nextProps.data[i].identifier + "']");
      const percentElement = $(this.refs.container).find(".pie-chart-legend__percent-value[data-identifier='" + nextProps.data[i].identifier + "']")
      percentElement.text(percentValue + "%");
      valueElement.text(value);
      nextProps.data[i].y === 0 || isNaN(nextProps.data[i].y) ? legendElement.hide() : legendElement.show();
    }
  }


  render() {
    if (isMobile()) {
      var legends = [], values = [], percentValues = [];
      for (var i = 0; i < this.props.legends.length; i++) {
        var identifier = this.props.legends[i].id;
        legends.push(
          <div className="pie-chart-legend__label" key={i}  style={{lineHeight: '20px'}}>
            <div className="pie-chart-legend__color"
                 style={{background: this.props.legends[i].parameters.legendColor}}/>
            <div key={i}>{this.props.legends[i].parameters.legendLabel}</div>
          </div>);
        values.push(<div className="pie-chart-legend__value" key={"v-" + i} data-identifier={identifier} style={{lineHeight: '20px'}}/>);
        percentValues.push(<div className="pie-chart-legend__percent-value" key={"v-" + i}
                                data-identifier={identifier} style={{lineHeight:  '20px'}}/>);
      }
      return (
        <div className="pie-chart-legends" ref="container">
          <div className="pie-chart-legend">
            {legends}
          </div>
          <div>
            {values}
          </div>
          <div>
            {percentValues}
          </div>
        </div>);
    } else {
      return <div className="pie-chart-legends" style={{flexDirection: "column", fontSize: "10px"}} ref="container">
        {
          this.props.legends.map((legend, index) => {
            return <div className="pie-chart-legend" key={index} data-identifier={legend.id}
                        style={{display: "flex", alignItems: "center", marginBottom: "8px"}}>
              <div className="pie-chart-legend__label">
                <div className="pie-chart-legend__color"
                     style={{background: legend.parameters.legendColor}}/>
                <div key={i} className="pie-legend-horizontal">{legend.parameters.legendLabel}</div>
              </div>
              <div className="pie-chart-legend__values">
                <div className="pie-chart-legend__value pie-legend-horizontal-value" data-identifier={legend.id}/>
                <div className="pie-chart-legend__percent-value pie-legend-horizontal-value"
                     data-identifier={legend.id}/>
              </div>
            </div>
          })
        }
      </div>
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/pie-chart/nonFloatingLegends.jsx